import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import App from "./App";
import Store from "./components/Store/Store";
import MqttProvider from "./components/Mqtt/MqttProvider";
import VarsProvider from "./components/VarsProvider/VarsProvider";
import ErrorBoundary from "./util/ErrorBoundary";
import translations from "./i18n/locales";

class ProviderApp extends Component {
  render() {
    let locale = navigator.language || "en-US";
    locale = window.location.search.replace("?locale=", "") || locale;
    const messages = translations(locale);
    return (
      <ErrorBoundary>
        <Store>
          <IntlProvider locale={locale} key={locale} messages={messages}>
            <VarsProvider>
              <MqttProvider>
                <App />
              </MqttProvider>
            </VarsProvider>
          </IntlProvider>
        </Store>
      </ErrorBoundary>
    );
  }
}

export default ProviderApp;
